export default __webpack_public_path__ + "static/media/sdpro.c1b0b2de.svg";